
@if (isLoading$ | async) {
    <app-loading-indicator></app-loading-indicator>
} @else {
    @if ((secontTaskList$ | async)?.length === 0) {
        <app-card [noMargin]="true" [showHeader]="false">
            <div card-body class="table-empty-state h-auto mb-5">
                <img id="img-empty-tasks" class="empty" alt="Empty" src="/assets/img/empty-tasks.svg" />
                @if (isAsap) {
                    <h2>No ASAP Reports to Display</h2>
                    <p>
                        Any incomplete reports will appear here 
                        <br />
                        until finished and submitted.
                    </p>
                } @else {
                    <h2>No Tasks to Display</h2>
                    <p>
                        Try adjusting your applied filters to view 
                        <br />
                        tasks that need your attention.
                    </p>
                }
            </div>
        </app-card>
    } @else {
        <div class="flights-list-wrapper">
            @for (task of secontTaskList$ | async; track task.data._id; let index = $index) {
            <ng-container [ngSwitch]="task.type">
                <app-home-task-card
                *ngSwitchCase="'flight'"
                [flight]="task.data"
                [showEdit]="false"
                [isLast]="index + 1 === (secontTaskList$ | async)?.length"
                ></app-home-task-card>

                <app-promotion-task-card
                *ngSwitchCase="'promotion'"
                [promotion]="task.data"
                [isLast]="index + 1 === (secontTaskList$ | async)?.length"
                ></app-promotion-task-card>

                <app-issue-task-card
                *ngSwitchCase="'issue'"
                [issue]="task.data"
                [isLast]="index + 1 === (secontTaskList$ | async)?.length"
                ></app-issue-task-card>

                <app-task-card
                *ngSwitchCase="'task'"
                [task]="task.data"
                [showEdit]="false"
                [isLast]="index + 1 === (secontTaskList$ | async)?.length"
                ></app-task-card>
            </ng-container>
            }
        </div>

        @if (total > pageSize) {
            <p-paginator
                (onPageChange)="onPageChange($event)"
                [first]="currentPage * pageSize"
                [rows]="pageSize"
                [totalRecords]="total"
                [showCurrentPageReport]="false"
                [showPageLinks]="false"
                [showJumpToPageDropdown]="true">
            </p-paginator>
        }
    }
}
